(function (angular) {
	'use strict';

	angular
		.module('investmentGoalChartModule')
		.factory('investmentGoalFactory', [
			'Big',
			'INVESTMENT_ENTITY_ID',
			'moment',
			'urlFactory',
			investmentGoalFunction
		]);

	function investmentGoalFunction(
		Big,
		INVESTMENT_ENTITY_ID,
		moment,
		urlFactory
	) {
		var factory = {
			getInvestmentGoalData: getInvestmentGoalData,
			submitInvestmentGoal: submitInvestmentGoal,
			getCurrentGoal: getCurrentGoal,
			deleteGoal: deleteGoal,
			getStandardChartSeries: getStandardChartSeries,
			getRangeChartSeries: getRangeChartSeries,
			getAmountOptionsForTimeHorizon: getAmountOptionsForTimeHorizon
		};

		return factory;
		
		function getInvestmentGoalData(
				chartType,
				goalType,
				goal,
				months,
				amount,
				frequency,
				dripEnabled) {
			
			var request = {
				'chartType': chartType,
				'goalType': goalType,
				'goalAccountTotalValue': goal,
				'goalAccountMonths': months,
				'recurringInvestmentAmount': amount,
				'recurringInvestmentFrequency': frequency,
				'dripEnabled': dripEnabled
			};
			
			return urlFactory.apiPostPromise('/api-secured/investment-goal/' + INVESTMENT_ENTITY_ID + '/generate-earnings-chart.json', request)
				.then(convertChartDataDateFormat);
		}
		
		function submitInvestmentGoal(
			goalType,
			goal,
			months,
			investmentType,
			amount,
			frequency,
			dripEnabled){
			
			var request = {
				'goalType': goalType,
				'goalAccountTotalValue': goal,
				'goalAccountMonths': months,
				'singleInvestmentAmount': investmentType === 'MANUAL_INVESTMENT' ? amount : 0,
				'recurringInvestmentAmount': investmentType === 'AUTO_INVEST' ? amount : 0,
				'recurringInvestmentFrequency': investmentType === 'AUTO_INVEST' ? frequency : null,
				'dripEnabled': dripEnabled
			};
			
			return urlFactory.apiPostPromise('/api-secured/investment-goal/' + INVESTMENT_ENTITY_ID + '/set-goal.json', request);
		}

		function getCurrentGoal(){
			return urlFactory.apiGetPromise('/api-secured/investment-goal/' + INVESTMENT_ENTITY_ID + '/select-goal');
		}

		function deleteGoal(){
			return urlFactory.apiPostPromise('/api-secured/investment-goal/' + INVESTMENT_ENTITY_ID + '/delete-current-goal');
		}

		function getStandardChartSeries(data, xValue, yValue){
			return data.map(function(dataPoint){
				return {
					x: dataPoint[xValue],
					y: parseFloat(Big(dataPoint[yValue])),
					marker: {
						states: {
							hover: {
								enabled: false
							}
						}
					}
				};
			});
		}

		function getRangeChartSeries(data, xValue, yValue){
			var areaRangeSeries = {
				series1: [],
				series2: [],
				series3: []
			};
			
			angular.forEach(data, function(value){
				areaRangeSeries.series1.push({
					x: value[xValue],
					high: parseFloat(Big(value[yValue + 'High1x'])),
					low: parseFloat(Big(value[yValue + 'Low1x']))
				});
				
				areaRangeSeries.series2.push({
					x: value[xValue],
					high: parseFloat(Big(value[yValue + 'High2x'])),
					low: parseFloat(Big(value[yValue + 'Low2x']))
				});
				
				areaRangeSeries.series3.push({
					x: value[xValue],
					high: parseFloat(Big(value[yValue + 'High3x'])),
					low: parseFloat(Big(value[yValue + 'Low3x']))
				});
			});
			
			return areaRangeSeries;
		}
		
		function convertChartDataDateFormat(response) {
			var data = response.data;

			data.chartData = data.chartData.map(function(dataPoint){
				dataPoint.date = moment.utc(dataPoint.date).valueOf();
				return dataPoint;
			});

			return data;
		}

		function getAmountOptionsForTimeHorizon(months) {
			var url = '/api-secured/investment-goal/' + INVESTMENT_ENTITY_ID + '/get-goal-amount-options.json';
			var formattedUrl = urlFactory.serializeParamsAndCreateUrl(url, {
				'goalAccountMonths': months
			});

			return urlFactory.apiGetPromise(formattedUrl).then(
				function(response) {
					var data = response.data;
					
					var amountOptions = data.goalOptions.map(function(option){
						var intValue = Number(new Big(option.value));
						option.value = intValue;
						option.sortIndex = intValue;
						return option;
					});

					var highestAmountValue = new Big(data.goalOptions[data.goalOptions.length - 1].value);
					var maximumAmount = highestAmountValue.times(4).toFixed(0);

					amountOptions.unshift({
						value: 0,
						label: 'Select amount',
						sortIndex: 0
					});

					amountOptions.push({
						value: 'other',
						label: 'Other amount',
					});

					return {
						'amountOptions': amountOptions,
						'maximumAmount': Number(maximumAmount),
						'minimumAmount': Number(Big(data.minimumAllowableValue))
					};
				});
		}
	}
})(window.angular);